import type { MouseEvent, ReactNode } from "react";
import { useEffect, useId, useRef } from "react";

export function Popup({
	open,
	title,
	onClose,
	children,
}: {
	open: boolean;
	title: string;
	onClose: () => void;
	children: ReactNode;
}) {
	const ref = useRef<HTMLDialogElement>(null);
	const titleId = useId();
	useEffect(() => {
		if (!open) return;
		const dialog = ref.current;
		if (!dialog) return;
		if (!dialog.open) dialog.showModal();
		return () => {
			if (dialog.open) dialog.close();
		};
	}, [open]);
	if (!open) return null;
	return (
		<dialog
			ref={ref}
			className="modal"
			aria-labelledby={titleId}
			onClose={onClose}
			onClick={(event) => dismissIfOutside(event, onClose)}
		>
			<div className="row tight">
				<h1 id={titleId}>{title}</h1>
			</div>
			{children}
		</dialog>
	);
}

function dismissIfOutside(event: MouseEvent<HTMLDialogElement>, onClose: () => void) {
	const box = event.currentTarget.getBoundingClientRect();
	if (
		event.clientX < box.left ||
		event.clientX > box.right ||
		event.clientY < box.top ||
		event.clientY > box.bottom
	) {
		onClose();
	}
}
